module.exports = __webpack_public_path__ + "static/media/11NEPAD11.c500bd8d.jpg";